import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Context,Hooks,Util,Request,Platform, XtLocale,Bridge } from "@xt/xtbase";
import QrCode from "@xt/QrCode";
import banner from "assets/images/home/banner.png";
import icon007 from "assets/images/home/007.png";
import fileCopyLineIcon from "assets/images/referral/file-copy-line.svg";
import qrCode from "assets/images/home/qrCode.png";
import libao from "assets/images/home/libao.png";
import bottomArrow from "assets/images/home/bottomArrow.png";
import giftLine from "assets/images/home/gift-line.png";
import SelectiveModal from './SelectiveModal';
import SelectiveDrawer from "./SelectiveDrawer";
import {
  get_profileInfo,
  get_inviteCodeList,
  get_shareInfo,
  get_inviteVipProgress,
  get_inviteVipLevelsV2,
  getMaxCfdCommissionRateFromVipLevelsResponse,
} from "@/api/referral";
import { useIntl, FormattedMessage } from "react-intl";
import { message, Space, Spin } from 'antd';
import InviteCodeModal from 'components/App/inviteCodeModal'
import copy from "copy-to-clipboard";
import ShareModal from "components/App/shareModal";
import CommonModal from "../../../App/commonModal"
import { gotoApp } from "@/utils/method";
import { getZenLang } from "../../../../utils/method";
import MyTeam from "./MyTeam";
import Members from "./Members";
import Bonus from "./Bonus";
import referralPlv1 from "assets/images/affiliate/partner-levels/vip1.png";
import referralPlv2 from "assets/images/affiliate/partner-levels/vip2.png";
import referralPlv3 from "assets/images/affiliate/partner-levels/vip3.png";
import referralPlv4 from "assets/images/affiliate/partner-levels/vip4.png";
import referralPlv5 from "assets/images/affiliate/partner-levels/vip5.png";
import referralPlv6 from "assets/images/affiliate/partner-levels/vip6.png";
import referralPlv7 from "assets/images/affiliate/partner-levels/vip7.png";
import referralOperateRulesChevron from "assets/images/referral/partner-level-ui/referral-operate-rules-chevron.png";

const REFERRAL_LEVEL_ICONS = [
  referralPlv1,
  referralPlv2,
  referralPlv3,
  referralPlv4,
  referralPlv5,
  referralPlv6,
  referralPlv7,
];

function clampReferralLevel(n) {
  const x = Number(n);
  if (!Number.isFinite(x) || x < 1) return 1;
  return Math.min(7, Math.floor(x));
}

/** 与后端字段对齐：任一为数字则作为 1–7 等级 */
function resolveReferralOperateLevel(profileInfo) {
  if (!profileInfo || typeof profileInfo !== "object") return 1;
  const raw =
    profileInfo.inviteLevel ??
    profileInfo.referralLevel ??
    profileInfo.referralOperateLevel ??
    profileInfo.level ??
    profileInfo.commissionLevel;
  return clampReferralLevel(raw != null ? raw : 1);
}

function referralLevelIcon(level) {
  return REFERRAL_LEVEL_ICONS[clampReferralLevel(level) - 1];
}

/**
 * 邀请 VIP 升级进度（下一等级）：两任务各占 50%。
 * - 两任务均未完成：50%×r1 + 50%×r2（两进度百分比相加）
 * - 其一完成：该维 50% + 另一维剩余（等价于 50×min(1,r1) + 50×min(1,r2)）
 * - 已满级：100%
 * @param {object|null} vip — GET /profile/invite/v2/vip-progress 的 result
 */
function computeInviteVipTotalProgressPercent(vip) {
  if (!vip || typeof vip !== "object") return 0;
  if (vip.isMaxLevel === true) return 100;

  const reqU = Number(vip.nextLevelRequiredDirectValidUserCount);
  const reqM = Number(vip.nextLevelRequiredOpenPositionMargin);
  const curU = Number(vip.currentDirectValidUserCount);
  const curM = Number(vip.currentOpenPositionMargin);

  const r1 = reqU > 0 ? Math.min(1, Math.max(0, curU / reqU)) : 1;
  const r2 = reqM > 0 ? Math.min(1, Math.max(0, curM / reqM)) : 1;

  return Math.min(100, 50 * r1 + 50 * r2);
}

/** 优先使用 VIP 接口的 currentVipLevel（0 视为 1 档展示） */
function resolveOperateLevelFromVip(vip, profileInfo) {
  if (vip && typeof vip === "object" && vip.currentVipLevel != null) {
    const lv = Number(vip.currentVipLevel);
    if (Number.isFinite(lv)) {
      if (lv <= 0) return 1;
      return clampReferralLevel(lv);
    }
  }
  return resolveReferralOperateLevel(profileInfo);
}

const {XtContext,XtAuth} = Context;
const {getOrigin, getUrl, getXTUrl, Big, compareVersion} = Util;
const {useDocumentWidth, useTranslation} = Hooks;

function Banner({ children, enableReferralV2Ui = true }) {
  const t = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const domeWidth = (useDocumentWidth() ?? 0) > 768;
  const [showSendRedPacket, setShowSendRedPacket] = useState(true);
  useEffect(()=>{
    if(domeWidth)
      setShowSendRedPacket(false);
  },[domeWidth]);
  const [appState] = React.useContext(XtContext);
  const {loginStatus, lang, userInfo} = appState;
  const {home_banner, titleCn, title, operate, button, linkText, subTitle, subTitleLine, subTitleLineWrap, subTitleLine3Wrap, highlight, header_bg, banner_bg, banner_t, banner_c, banner_l, banner_l_content, banner_tabMiddle, banner_rCol, banner_img, icon007Img, banner_r, change, changeTitle, changeOperation, mbTip,
    rebate, rebate1, copyIconWrap, copyIconImg, referralField, referralLabel, referralInput, referralInputValue, linkUrl, qrCodeInvite, qrCodeImg, inviteOperation, giftLineImg, libaoImg, banner_bg1, bottomArrowImg
  } = styles
  const [loginQuery, setLoginQuery] = useState("");
  const [copyLinkUrl, setCopyLinkUrl] = useState("");
  const [isShowSelectiveModal, setIsShowSelectiveModal] = useState(false)
  const [isShowInviteCodeModal, setIsShowInviteCodeModal] = useState(false)
  const [highCommissionRate, setHighCommissionRate] = useState('40%')
  const [profileInfo, setProfileInfo] = useState({})
  const [vipProgress, setVipProgress] = useState(null)
  const [inviteCodeList, setInviteCodeList] = useState([])

  const [isShowShareModal, setIsShowShareModal] = useState(false);
  const [shareInfo, setShareInfo] = useState({})

  const [isShowRebateRuleModal, setIsShowRebateRuleModal] = useState(false);
  const [activeTab, setActiveTab] = useState("invite");
  // 身份未拉取完成前不展示依赖身份的按钮，避免误点跳错页
  const [identityReady, setIdentityReady] = useState(false);
  // 仅当「未登录」状态稳定一段时间后再展示登录/申请按钮，避免拿到登录态前闪一下再变
  const [showLoginButton, setShowLoginButton] = useState(false);
  // 挂载后短时内一律显示 loading，等登录态稳定后再根据 showLoginButton 等决定，避免中间闪「apply for a partner」
  const [mountSettled, setMountSettled] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMountSettled(true), 350);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (loginStatus !== 0) {
      setShowLoginButton(false);
      return;
    }
    const t = setTimeout(() => setShowLoginButton(true), 200);
    return () => clearTimeout(t);
  }, [loginStatus]);

  const showMainButtonLoading =
    !mountSettled ||
    loginStatus == null ||
    loginStatus === undefined ||
    (loginStatus == 1 && !identityReady) ||
    (loginStatus === 0 && !showLoginButton);

  const operateLevel = resolveOperateLevelFromVip(vipProgress, profileInfo);
  const operateNextLevel = (() => {
    if (vipProgress?.isMaxLevel) return operateLevel;
    const n = Number(vipProgress?.nextVipLevel);
    if (Number.isFinite(n) && n > 0) return clampReferralLevel(n);
    return Math.min(7, operateLevel + 1);
  })();
  const operateProgressPct = vipProgress
    ? computeInviteVipTotalProgressPercent(vipProgress)
    : resolveReferralOperateLevel(profileInfo) >= 7
      ? 100
      : Math.max(6, ((resolveReferralOperateLevel(profileInfo) - 1) / 6) * 100);

  /** 等级展示文案用 i18n home.referralOperateLevel，不用接口里的 name */
  const currentLevelForLabel =
    vipProgress?.currentVipLevel != null && Number.isFinite(Number(vipProgress.currentVipLevel))
      ? Math.max(1, Number(vipProgress.currentVipLevel))
      : operateLevel;
  const nextLevelForLabel = vipProgress?.isMaxLevel
    ? currentLevelForLabel
    : vipProgress?.nextVipLevel != null && Number.isFinite(Number(vipProgress.nextVipLevel))
      ? Math.max(1, Number(vipProgress.nextVipLevel))
      : operateNextLevel;
  const operateLevelTitleText = t("home.referralOperateLevel", { n: currentLevelForLabel });
  const operateNextLevelLabelText = t("home.referralOperateLevel", { n: nextLevelForLabel });

  const { formatMessage: f } = useIntl();

  const onCloseSelectiveModal = () => {
    console.log("setIsShowSelectiveModal@@@@")
    setIsShowSelectiveModal(false)
  }

  const onOkSelectiveModal = () => {
    getInviteCodeList()
    setIsShowSelectiveModal(true)
  }

  const onCloseInviteCodeModal = () => {
    setIsShowInviteCodeModal(false)
  }

  const onOkInviteCodeModal = () => {
    setIsShowInviteCodeModal(true)
  }

  const onOkRebateRuleClose = () => {
    // setIsShowRebateRuleModal(true)
    window.open(encodeURI(`https://spikex.zendesk.com/hc/${getZenLang()}/categories/5181251121438-Affiliate-program`));
  }

  const onRebateRuleClose = () => {
    setIsShowRebateRuleModal(false)
  }

  const referralTabs = [
    { key: "invite", label: t("home.tabInvite") },
    { key: "myTeam", label: t("home.tabMyTeam") },
    { key: "members", label: t("home.tabMembers") },
    { key: "bonus", label: t("home.tabBonus") },
  ];

  const renderReferralTabHeader = () => (
    <div className={styles.tabHeader}>
      {referralTabs.map((tab) => {
        const active = activeTab === tab.key;
        return (
          <div
            key={tab.key}
            className={active ? styles.tabItemActive : styles.tabItem}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </div>
        );
      })}
    </div>
  );

  const copyToClipboard = (text) => navigator.clipboard?.writeText && navigator.clipboard.writeText(text)

  useEffect(()=>{
    setLoginQuery("?backurl="+encodeURIComponent(location.href));
    const getData = async() => {
      getCommissionLevel()
    }
    getData();
    if(Platform.isInApp())
    {
      setShowSendRedPacket(compareVersion(Bridge.getVersion(),"4.21.0") >= 0);
    }
  },[]);

  useEffect(()=>{
    const getData = async() => {
      if (loginStatus != 1) {
        setIdentityReady(false);
        setVipProgress(null);
        return;
      }
      setIdentityReady(false);
      try {
        await Promise.all([
          getProfileInfo(),
          getInviteCodeList(),
          (async () => {
            try {
              const data = await get_inviteVipProgress();
              setVipProgress(data ?? null);
            } catch (_) {
              setVipProgress(null);
            }
          })(),
        ]);
      } finally {
        setIdentityReady(true);
      }
    }
    getData()
  },[loginStatus]);

  const getCommissionLevel = async () => {
    try {
      const res = await get_inviteVipLevelsV2();
      const maxRate = getMaxCfdCommissionRateFromVipLevelsResponse(res);
      setHighCommissionRate(
        maxRate != null ? `${Big(maxRate * 100).toFixedMaxCy(0)}%` : "40%"
      );
    } catch (_) {
      setHighCommissionRate("40%");
    }
  };

  const getRootDomain = () => {
    let domain = document.domain;//先获取当前访问的全域名
    let domain2 = domain.substring(domain.indexOf('.')+1);//截取第一个点的位置来获取根域名,这样只能获取二级域名的根域名，如果直接是不带www的域名访问，那么就会直接获取域名的后缀
    return domain2
  }

  const getProfileInfo = async() => {
    localStorage.setItem('isPartner', false);
    const profileInfo = await get_profileInfo()
    setProfileInfo(profileInfo)
    setCopyLinkUrl(`https://www.${getRootDomain()}/${lang}/accounts/register?ref=`);
    localStorage.setItem('isPartner', profileInfo?.isPartner);
  }

  const getInviteCodeList = async() => {
    const inviteCodeList = await get_inviteCodeList({
      params: {
        pageSize: 20
      }
    })
    setInviteCodeList(inviteCodeList?.items || [])
  }

  const getShareInfo = async() => {
    const shareInfoList = await get_shareInfo()
    const shareInfo = {}
    if(lang == 'zh-HK') {
      shareInfo = shareInfoList?.find((_)=>_.lang == 'zh-hk')
    } else if(lang == 'zh-CN') {
      shareInfo = shareInfoList?.find((_)=>_.lang == 'zh')
    } else {
      shareInfo = shareInfoList?.find((_)=>_.lang == lang)
    }
    // console.log(shareInfo, 'shareInfo')
    setShareInfo(shareInfo || {})
  }

   // 复制Code
   const onCopyCode = (inviteCode) => {
    copy(inviteCode);
    messageApi.open({
      type: 'success',
      content: t("home.copySuccess"),
    });
  };

  // 复制链接
  const onCopyLink = () => {
    copy(copyLinkUrl + profileInfo?.inviteCode);
    messageApi.open({
      type: 'success',
      content: t("home.copySuccess"),
    });
  };

  // 分享
  const onShare = () => {
    getShareInfo()
    setIsShowShareModal(true);
  };

  // 关闭分享弹层
  const onShareClose = () => {
    setIsShowShareModal(false);
};

  const renderReferralFields = () => {
    const fullLink = `${copyLinkUrl}${profileInfo?.inviteCode || ""}`;
    return (
      <>
        <div className={referralField}>
          <div className={referralLabel}>{t("home.referralCode")}</div>
          <div className={referralInput}>
            <div className={referralInputValue}>{profileInfo?.inviteCode}</div>
            <span className={copyIconWrap} onClick={() => onCopyCode(profileInfo?.inviteCode)}>
              <img src={fileCopyLineIcon} alt="" className={copyIconImg} />
            </span>
          </div>
        </div>
        <div className={referralField}>
          <div className={referralLabel}>{t("home.referralUrl")}</div>
          <div className={referralInput}>
            <div className={linkUrl}>{fullLink}</div>
            <span className={copyIconWrap} onClick={onCopyLink}>
              <img src={fileCopyLineIcon} alt="" className={copyIconImg} />
            </span>
          </div>
        </div>
      </>
    );
  };

  const renderReferralSubtitle = () => (
    <div className={subTitle}>
      <p className={subTitleLine}>
        <FormattedMessage
          id="home.subTitleLine1"
          values={{
            span: (chunks) => <span className={highlight}>{chunks}</span>
          }}
        />
      </p>
      <p className={subTitleLine}>
        {t("home.subTitleLine2")}
      </p>
      <div className={subTitleLine3Wrap}>
        <p className={`${subTitleLine} ${subTitleLineWrap}`}>
          <FormattedMessage
            id="home.subTitleLine3"
            values={{
              highCommissionRate,
              span: (chunks) => <span className={highlight}>{chunks}</span>
            }}
          />
        </p>
      </div>
    </div>
  );

  return (
    <div className={home_banner}>
      {contextHolder}
      <div className={loginStatus == 1 && !domeWidth ? banner_bg1 : banner_bg} style={loginStatus == 1 || !domeWidth ? {} : {backgroundImage:`url(${banner})`}}>
        <div className={header_bg}></div>
        <div className={banner_c}>
          <div className={banner_l}>
            <div className={banner_l_content}>
              <div className={banner_t}>
                <h1 className={`${lang === "zh-CN" ? titleCn : titleCn}` }>{ t("home.title") }</h1>
                {domeWidth && renderReferralSubtitle()}
                {!domeWidth && <div className={mbTip}>{renderReferralSubtitle()}</div>}
              </div>
              <div className={banner_img}>
                <img src={icon007} className={icon007Img} alt="referral illustration" />
              </div>
            </div>
           
            <div className={operate}>
              {showMainButtonLoading && (
                <span className={styles.operateLoading}>
                  <Spin size="small" />
                </span>
              )}
              {/* 未登录：登录 + 查看返佣规则 */}
              {!showMainButtonLoading && loginStatus != 1 && (
                <>
                  <a href={getUrl("/accounts/login"+loginQuery)} className={button}>
                    <div>{ t("header.login") }</div>
                  </a>
                  <div onClick={onOkRebateRuleClose} className={linkText}>
                    { t("home.query") }
                  </div>
                </>
              )}
              {/* 已登录：设计稿 operate 卡片（Figma 11197:5116）+ 合伙人管理按钮 */}
              {!showMainButtonLoading && loginStatus == 1 && identityReady && (
                <>
                  <div
                    className={styles.operateCard}
                    data-figma-node-id="11197:5116"
                  >
                    <div className={styles.operateCardTop}>
                      <div className={styles.operateLevelRow}>
                        <img
                          src={referralLevelIcon(operateLevel)}
                          alt=""
                          className={styles.operateBadgeIcon}
                        />
                        <span className={styles.operateLevelTitle}>
                          {operateLevelTitleText}
                        </span>
                      </div>
                      <button
                        type="button"
                        className={styles.operateRulesBtn}
                        onClick={() => {
                          window.location.href = getUrl("/affiliate");
                        }}
                      >
                        <span>{t("home.query")}</span>
                        <span className={styles.operateRulesChevronFrame} aria-hidden>
                          <img
                            src={referralOperateRulesChevron}
                            alt=""
                            className={styles.operateRulesChevron}
                          />
                        </span>
                      </button>
                    </div>
                    <div className={styles.operateMetricsRow}>
                      <span className={styles.operateMetricPrimary}>{t("home.referralOperateMetric1")}</span>
                      <span className={styles.operateMetricSecondary}>{t("home.referralOperateMetric2")}</span>
                    </div>
                    <div className={styles.operateProgressBlock}>
                      <div className={styles.operateProgressTrack}>
                        <div
                          className={styles.operateProgressFill}
                          style={{ width: `${operateProgressPct}%` }}
                        />
                      </div>
                      <div className={styles.operateProgressLabels}>
                        <span>{operateLevelTitleText}</span>
                        <span>{operateNextLevelLabelText}</span>
                      </div>
                    </div>
                  </div>
                  {profileInfo?.isPartner && (
                    <a href={`${getUrl("/affiliate/admin")}`} className={button}>
                      <div>{ t("home.partnerManagement") }</div>
                    </a>
                  )}
                </>
              )}
            </div>
          </div>
          {loginStatus == 1 && enableReferralV2Ui && (
            <div className={banner_tabMiddle}>{renderReferralTabHeader()}</div>
          )}
          
          { loginStatus == 1 && enableReferralV2Ui && domeWidth && activeTab === "invite" && (
            <div className={banner_rCol}>
              <div className={banner_r}>
                {renderReferralFields()}
                <div className={qrCodeInvite}>
                  <div className={inviteOperation} onClick={onShare}>
                    <div>{ t("home.invite") }</div>
                  </div>
                  <img src={qrCode} onClick={onOkInviteCodeModal} className={qrCodeImg} />
                  <img src={libao} onClick={onShare} className={libaoImg} />
                </div>
              </div>
            </div>
          )}
          { loginStatus == 1 && enableReferralV2Ui && !domeWidth && activeTab === "invite" && (
            <div className={banner_rCol}>
              <div className={banner_r}>
                {renderReferralFields()}
                <div className={qrCodeInvite}>
                  <div className={inviteOperation} onClick={onShare}>
                    <img src={giftLine} className={giftLineImg} />
                    <div>{ t("home.invite") }</div>
                  </div>
                  <img src={qrCode} onClick={onOkInviteCodeModal} className={qrCodeImg} />
                </div>
              </div>
            </div>
          )}

          {/* { loginStatus == 1 && showSendRedPacket && (
          // { (
            <div className={banner_r} onClick={() => gotoApp('/red-packet-create')}>
              <div className={styles.sendPacket}>
                <div className={styles.sendPacketLeft}>
                  <div className={styles.sendPacketTitle}>{t('redPacket.sendRedPacket')}</div>
                  <div className={styles.sendPacketDesc}>{t('redPacket.sendRedPacket.desc')}</div>
                  <div className={styles.sendPacketBtn}>
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.44095 4.96961H0.779605C0.349263 4.96961 0 4.62035 0 4.19001C0 3.75967 0.349263 3.4104 0.779605 3.4104H9.44096L7.36096 1.3304C7.05691 1.02635 7.05691 0.532081 7.36096 0.228035C7.665 -0.0760115 8.15927 -0.0760115 8.46332 0.228035L11.772 3.53512C11.9519 3.71504 12.0253 3.96156 11.9923 4.19586C12.0213 4.42664 11.9473 4.66797 11.7704 4.84489L8.46332 8.15197C8.15927 8.45602 7.665 8.45602 7.36096 8.15197C7.05691 7.84792 7.05691 7.35366 7.36096 7.04961L9.44095 4.96961Z" fill="black" fill-opacity="0.8"/>
                    </svg>
                  </div>
                </div>
                <div className={styles.sendPacketRight}>
                  <svg width="62" height="57" viewBox="0 0 62 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_11897_29021" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="13" y="0" width="41" height="56">
                      <rect x="14.3433" y="0.462687" width="38.8657" height="54.597" rx="3.23881" fill="white" stroke="black" stroke-width="0.925373"/>
                    </mask>
                    <g mask="url(#mask0_11897_29021)">
                      <path d="M55.0597 5.55226C55.0597 17.042 45.5401 26.3732 33.7761 26.3732C22.0121 26.3732 12.4925 17.042 12.4925 5.55226C12.4925 -5.93747 22.0121 -15.2686 33.7761 -15.2686C45.5401 -15.2686 55.0597 -5.93747 55.0597 5.55226Z" fill="#EBEBEB" stroke="black" stroke-width="0.925373"/>
                      <rect x="14.2806" y="0.4" width="38.991" height="54.7224" rx="3.30149" stroke="black" stroke-width="0.8"/>
                    </g>
                    <path d="M14.4548 33.5854C11.8594 35.2762 9.70019 37.5559 8.15315 40.2388C6.60611 42.9217 5.71497 45.9319 5.55224 49.0243C5.55224 51.7837 6.55983 53.7981 8.1609 54.7363L10.6453 56.116C9.04424 55.1916 8.05045 53.2186 8.03664 50.404C8.22188 47.324 9.1307 44.3311 10.6895 41.6678C12.2482 39.0046 14.413 36.7461 17.0082 35.0755C19.4926 33.6958 21.7424 33.5026 23.371 34.4546L20.8866 33.0749C19.1889 32.0263 17.0082 32.1643 14.4548 33.5854Z" fill="#19191E"/>
                    <path d="M12.9918 56.6402C10.0381 56.6402 8.18851 54.2671 8.1747 50.4591C8.33796 47.3935 9.22316 44.4099 10.7582 41.751C12.2932 39.0921 14.4347 36.8332 17.0082 35.1581C18.1917 34.4187 19.5474 34.0002 20.9419 33.944C23.9094 33.944 25.759 36.3309 25.759 40.1527C25.5947 43.2161 24.7089 46.1974 23.1739 48.8539C21.6389 51.5104 19.498 53.7669 16.9254 55.4398C15.7428 56.1791 14.3859 56.5932 12.9918 56.6402Z" fill="white"/>
                    <path d="M13.4684 55.2051C11.1489 55.0768 9.80843 52.9721 9.97731 49.7232C10.2502 47.1154 11.0861 44.6087 12.4171 42.4074C13.748 40.206 15.5363 38.3721 17.6363 37.055C18.6006 36.4757 19.685 36.1777 20.7827 36.1903C23.1131 36.3192 24.4529 38.4356 24.2725 41.6957C23.9989 44.3017 23.1626 46.8063 21.8318 49.0057C20.501 51.205 18.7133 53.0369 16.6141 54.3521C15.6505 54.9314 14.5654 55.2256 13.4684 55.2051Z" fill="#45BF76"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0079 39.6677C22.1764 39.736 22.1709 40.0245 21.9959 40.3067L18.9515 45.2139L20.7486 46.9898C20.9187 47.1578 20.6983 47.6559 20.3827 47.8167L19.0864 48.4772C18.9894 48.5266 18.903 48.5253 18.8508 48.4736L17.6595 47.2965L16.463 49.2251L16.0739 49.8523C15.8924 50.145 15.6055 50.3146 15.442 50.226C15.2866 50.1419 15.3006 49.855 15.4735 49.5772L21.411 40.0387C21.5805 39.7663 21.8453 39.6018 22.0079 39.6677ZM19.7249 41.4639C19.9 41.1817 19.9055 40.8933 19.737 40.825C19.5743 40.7591 19.3096 40.9236 19.14 41.1959L17.5197 43.799L16.3114 42.605C16.2591 42.5533 16.1727 42.552 16.0757 42.6015L14.7795 43.2619C14.4639 43.4227 14.2435 43.9208 14.4136 44.0888L16.225 45.8789L13.2025 50.7345C13.0296 51.0123 13.0157 51.2991 13.171 51.3833C13.3346 51.4719 13.6214 51.3023 13.803 51.0096L14.1921 50.3824L19.7249 41.4639Z" fill="#2D2D2E"/>
                    <path d="M20.9415 34.0959C23.8262 34.0959 25.6206 36.4138 25.6206 40.1528C25.46 43.1941 24.5823 46.1544 23.0592 48.7919C21.536 51.4295 19.4105 53.6697 16.8561 55.3296C15.6938 56.056 14.3613 56.4652 12.9915 56.5162C10.1206 56.5162 8.32625 54.1982 8.31245 50.473C8.473 47.4318 9.35066 44.4715 10.8739 41.834C12.397 39.1964 14.5225 36.9562 17.0769 35.2963C18.24 34.5735 19.5728 34.169 20.9415 34.1235V34.0959ZM20.9415 33.8062C19.5233 33.861 18.1438 34.2842 16.9389 35.0341C14.3438 36.7219 12.1846 38.999 10.6375 41.6797C9.09032 44.3604 8.19906 47.3687 8.03638 50.4592C8.03638 54.4604 10.0654 56.7783 12.9915 56.7783C14.4109 56.7305 15.7922 56.3068 16.9941 55.5504C19.5904 53.8693 21.7518 51.5978 23.3015 48.9216C24.8512 46.2455 25.7453 43.2406 25.9104 40.1528C25.9104 36.1241 23.8814 33.8062 20.9415 33.8062Z" fill="#19191E"/>
                    <path d="M21.1939 36.3167C23.3708 36.5603 24.5006 38.7152 24.139 41.9467C23.7236 44.5617 22.775 47.0461 21.3704 49.1971C19.9658 51.348 18.1452 53.1046 16.057 54.3235C15.1097 54.8532 14.0645 55.0943 13.0259 55.0227C10.8594 54.7802 9.72954 52.6254 10.0794 49.4046C10.4948 46.7896 11.4434 44.3053 12.848 42.1543C14.2526 40.0033 16.0732 38.2467 18.1614 37.0278C19.109 36.5013 20.1539 36.2643 21.1912 36.3406L21.1939 36.3167ZM21.2219 36.0663C20.1463 35.9939 19.0644 36.2432 18.0826 36.7895C15.961 38.0291 14.1113 39.8148 12.6845 42.001C11.2577 44.1872 10.2942 46.712 9.87246 49.3693C9.48545 52.8274 10.7924 55.0021 13.0005 55.2493C14.0763 55.3279 15.1596 55.0782 16.1398 54.526C18.2617 53.2924 20.1125 51.5117 21.5408 49.3296C22.9691 47.1475 23.9344 44.626 24.3577 41.9712C24.7474 38.4893 23.4404 36.3146 21.2219 36.0663Z" fill="#19191E"/>
                    <circle cx="33.7761" cy="26.3731" r="5.61493" fill="#45BF76" stroke="black" stroke-width="0.8"/>
                    <rect width="5.16883" height="5.13985" rx="1.02086" transform="matrix(0.709875 0.704327 -0.689942 0.723864 33.5462 22.8)" fill="#19191E"/>
                    <rect width="3.42552" height="3.38507" transform="matrix(0.709875 0.704327 -0.689942 0.723864 33.6373 24.0597)" fill="white"/>
                    <path d="M3.5 8L4.44532 10.5547L7 11.5L4.44532 12.4453L3.5 15L2.55468 12.4453L0 11.5L2.55468 10.5547L3.5 8Z" fill="#19191E"/>
                    <path d="M46.7313 3.70154L47.3562 5.39013L49.0448 6.01497L47.3562 6.63981L46.7313 8.3284L46.1065 6.63981L44.4179 6.01497L46.1065 5.39013L46.7313 3.70154Z" fill="#19191E"/>
                    <path d="M58.7612 42.3084L59.419 44.0861L59.4559 44.1859L59.5557 44.2228L61.3334 44.8806L59.5557 45.5384L59.4559 45.5753L59.419 45.6751L58.7612 47.4528L58.1034 45.6751L58.0665 45.5753L57.9667 45.5384L56.189 44.8806L57.9667 44.2228L58.0665 44.1859L58.1034 44.0861L58.7612 42.3084Z" fill="#45BF76" stroke="black" stroke-width="0.462687"/>
                  </svg>
                </div>
              </div>
            </div>
          )} */}
        </div>

      </div>
      {!domeWidth && <SelectiveDrawer onClose={onCloseSelectiveModal} isShowModal={isShowSelectiveModal} inviteCodeList={inviteCodeList} getInviteCodeList={getInviteCodeList} getProfileInfo={getProfileInfo} />}
      {domeWidth &&<SelectiveModal onClose={onCloseSelectiveModal} isShowModal={isShowSelectiveModal} inviteCodeList={inviteCodeList} getInviteCodeList={getInviteCodeList} getProfileInfo={getProfileInfo} />}
      <InviteCodeModal onClose={onCloseInviteCodeModal} isShowModal={isShowInviteCodeModal} qrUrl={copyLinkUrl + profileInfo?.inviteCode } inviteeCommissionRate = {profileInfo?.inviteeCommissionRate * 100 + '%'} inviteCode={profileInfo?.inviteCode} />
      <ShareModal
        isShowModal={isShowShareModal}
        onClose={onShareClose}
        qrUrl={copyLinkUrl + (profileInfo?.inviteCode || "")}
        inviteCode={profileInfo?.inviteCode}
      />
      <CommonModal width={domeWidth ? 480 : 311} title={`Spikex.COM${t("home.rebatePlan")}`} isShowModal={isShowRebateRuleModal} onClose={onRebateRuleClose}>
        <div className="RebateRuleModal">
          <div className="item">
            <div className="title">{t("home.rebatePlan1")}</div>
            <div className="tip">{t("home.rebatePlan1Tip")}</div>
            <div className="text">{t("home.rebatePlan1Text1")}</div>
            <div className="text">{t("home.rebatePlan1Text2")}</div>
          </div>
          <div className="item">
            <div className="title">{t("home.rebatePlan2")}</div>
            <div className="tip">{t("home.rebatePlan2Tip")}</div>
            <div className="text">{t("home.rebatePlan2Text1")}</div>
            <div className="text">{t("home.rebatePlan2Text2")}</div>
            <div className="text" dangerouslySetInnerHTML={{__html:t("home.rebatePlan2Text3",[onOkSelectiveModal])}}>
              {/* {t("home.rebatePlan2Text3")} */}
            </div>
          </div>
          <div className="item">
            <div className="title">{t("home.rebatePlan3")}</div>
            <div className="tip">{t("home.rebatePlan3Tip")}</div>
            <div className="text">{t("home.rebatePlan3Text1")}</div>
            <div className="text">{t("home.rebatePlan3Text2")}</div>
          </div>
          <div className="item">
            <div className="title">{t("home.rebatePlan4")}</div>
            <div className="text">{t("home.rebatePlan4Tip1")}</div>
            <div className="text">{t("home.rebatePlan4Tip2")}</div>
            <div className="text">{t("home.rebatePlan4Tip3")}</div>
            <div className="text1">{t("home.rebatePlan4Text1")}</div>
            <div className="text1">{t("home.rebatePlan4Text2")}</div>
            <div className="text1Tip">{t("home.rebatePlan4Text2Tip1")}</div>
            <div className="text1Tip">{t("home.rebatePlan4Text2Tip2")}</div>
            <div className="text1">{t("home.rebatePlan4Text3")}</div>
          </div>
        </div>
      </CommonModal>
      <div className={styles.tabContentArea}>
        <div className={styles.tabPanel}>
          {loginStatus != 1 || !enableReferralV2Ui ? (
            children
          ) : (
            <>
              {activeTab === "invite" ? children : null}
              {activeTab === "myTeam" ? <MyTeam /> : null}
              {activeTab === "members" ? <Members /> : null}
              {activeTab === "bonus" ? <Bonus /> : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Banner;
